import HistoryIcon from '@mui/icons-material/History'
import LaunchIcon from '@mui/icons-material/Launch'
import Avatar from '@mui/material/Avatar'
import Chip from '@mui/material/Chip'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import Tooltip from '@mui/material/Tooltip'

import Adres from '@components/Adres'
import { DisciplineIcon } from '@components/DisciplineIcon'
import Uitvoerende from '@components/Uitvoerende'
import { formatDate } from '@util/date-util'
import { createBadge } from '@util/kpi-util'

import type { Opdracht } from '../../../opdracht/types/Opdracht'
import { CombiOpdrachtKpi } from '../../../opdrachten/combi/components/CombiOpdrachtKpi'
import { OpdrachtStatus } from '../../../opdrachten/components/OpdrachtStatus'
import { StyledIconLink } from '../../../theme/components/StyledIconLink'

const fromDetails = (opdracht, prop) =>
  opdracht && opdracht.details ? opdracht.details[prop] : ''
const fromCombi = (opdracht, prop) =>
  opdracht && opdracht.details && opdracht.details.combi
    ? opdracht.details.combi[prop] || ''
    : ''

function DirtyIcon() {
  return (
    <span style={{ paddingLeft: 7 }}>
      <Tooltip title="Door wijzigingen worden KPI's herberekend">
        <HistoryIcon />
      </Tooltip>
    </span>
  )
}

function StatusIcon({ opdracht }) {
  const kpi = fromCombi(opdracht, 'kpi')
  const badge = kpi && createBadge(kpi)

  if (fromCombi(opdracht, 'isDirty')) return <DirtyIcon />

  return badge ? <CombiOpdrachtKpi kpi={kpi} /> : null
}
const STATUS_OPLEVERING = 500

interface Props {
  opdracht: Opdracht
}

export const OpdrachtenTableRow = ({ opdracht }: Props) => {
  return (
    <>
      <TableRow key={opdracht.opdrachtId}>
        <TableCell>
          <StatusIcon opdracht={opdracht} />
        </TableCell>
        <TableCell>{opdracht.opdrachtId}</TableCell>
        <TableCell>
          <Chip
            variant="outlined"
            avatar={
              <Tooltip
                title={fromCombi(opdracht, 'realisatietype')}
                placement="right"
              >
                <Avatar
                  sx={{
                    color: 'black !important',
                    cursor: 'default',
                    backgroundColor: '#eeeeee',
                  }}
                >
                  {fromCombi(opdracht, 'realisatietype').substring(0, 1)}
                </Avatar>
              </Tooltip>
            }
            label={formatDate(fromCombi(opdracht, 'realisatiedatum'))}
          />
        </TableCell>
        <TableCell>
          <DisciplineIcon
            disciplineCode={opdracht.discipline}
            toolTip={opdracht.disciplineLabel}
          />
        </TableCell>
        <TableCell>
          {opdracht.details && <Adres {...opdracht.details} />}
        </TableCell>
        <TableCell>{opdracht.netbeheerder}</TableCell>
        <TableCell>
          <Uitvoerende {...opdracht} />
        </TableCell>
        <TableCell>
          {opdracht.status === STATUS_OPLEVERING ? (
            <OpdrachtStatus opdracht={opdracht} text={opdracht.statusText} />
          ) : (
            <p>{opdracht.statusText}</p>
          )}
        </TableCell>
        <TableCell>
          {formatDate(fromDetails(opdracht, 'creatieDatum'))}
        </TableCell>
        <TableCell>{formatDate(opdracht.changed)}</TableCell>
        <TableCell>
          <StyledIconLink
            title={`Navigeer naar opdracht ${opdracht.opdrachtId}`}
            icon={<LaunchIcon />}
            href={`/combiopdracht/${opdracht.opdrachtId}`}
          />
        </TableCell>
      </TableRow>
    </>
  )
}
